<template>
    <div class="speaker columns is-flex" v-if="speaker">
      <div class="column columns is-offset-one-quarter is-half">
        <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteSpeaker(speaker.id)"/>
        <div class="speaker-data" v-if="speaker.type === 'speaker'">
          <b-field>
              <b-input placeholder="Заголовок" required v-model="speaker.title" @change="handleUpdate"></b-input>
          </b-field>
          <b-field>
              <b-input placeholder="Имя спикера" required v-model="speaker.name" @change="handleUpdate"></b-input>
          </b-field>
          <b-field>
            <Editor
              :id="'speaker-editor-' + speaker.id"
              placeholder="Текст информации"
              :editorToolbar="customToolbar"
              v-model="text"
            />
          </b-field>
        </div>
        <div v-else class="speaker-data">
          <b-input v-model="speaker.title" placeholder="Подзаголовок" @change="handleUpdate"/>
        </div>
      </div>
      <div class="column">
        <input type="file" @change='callLoadSpeakerPhoto' hidden ref="loadSpeakerPhotoButton"/>
        <div  v-if="speaker.type === 'speaker'">
          <div class="rounded-photo-wrapper centered speaker-photo" @click="$refs.loadSpeakerPhotoButton.click()" v-if="!speaker.photo && !base64photo">
              <div>
                <span>Сменить фото</span>
              </div>
            </div>
          <div v-else 
          class="speaker-photo" 
          :style="(base64photo) ? 'background: url(' + base64photo + ')' : 'background: url(/upload/photos/' + speaker.photo">
            <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteSpeakerPhoto(speaker.id)"/>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { VueEditor as Editor } from 'vue2-editor'

export default {
  name: 'EventSpeakerItem',
  data () {
    return {
      text: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['link']
      ],
      base64photo: ''
    }
  },
  props: {
    speaker: { type: Object, required: true },
    index: { required: true }
  },
  methods: {
    ...mapActions(['updateEventSpeaker', 'deleteSpeaker']),
    handleUpdate () {
      this.speaker.description = this.text
      this.updateEventSpeaker(this.speaker)
    },
    callLoadSpeakerPhoto (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      this.speaker.newPhoto = formData
      reader.onload = (e) => {
        this.base64photo = e.target.result
        this.handleUpdate()
      }
    },
    deleteSpeakerPhoto (id) {
      setTimeout(() => {
        this.base64photo = ''
        this.$refs.loadSpeakerPhotoButton.value = ''
        this.speaker.photo = null
        this.speaker.newPhoto = null
        this.handleUpdate()
      }, 10)
    }
  },
  components: { Editor },
  watch: {
    text () {
      this.handleUpdate()
    }
  },
  created () {
    this.text = this.speaker.description || ''
  }
}
</script>
<style scoped>
.speaker {
  margin: 25px 0;
  flex-direction: row;
}
.speaker .delete-icon {
  position: inherit;
  height: 24px;
}
.speaker-data {
  width: 100%;
  margin: 0 0 0 25px;
}
.speaker-photo {
  width: 120px;
  height: 120px;
  margin: auto 15px;
  border-radius: 50%;
  position: relative;
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}
.speaker-photo .delete-icon {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 25px;
}
</style>
<style>
.speaker-data .quillWrapper{
  width: 100%;
  height: 300px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// EventItemSpeaker.vue?501cd3bb